import React, { useEffect, useRef, useState } from 'react';
import { Button, Row, Col } from 'reactstrap';
import { requiresRangeQuoteForVehicleType } from '../vehicleTypeApi';

const ORDER_SUBMIT_LOCK_MS = 25000;

const normalizeCurrencyValue = value => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

const ConfirmButtons = ({
  isExpedited,
  price,
  isScheduled,
  handleBack,
  handleConfirm,
  setIsSaved,
  setOrderStatus,
  setShipmentStatus,
  vehicleType,
  priceRangeLow,
  priceRangeHigh,
  quoteLineItems = []
}) => {
  const [isOrderSubmitDisabled, setIsOrderSubmitDisabled] = useState(false);
  const submitUnlockTimeoutRef = useRef(null);
  const normalizedPrice = normalizeCurrencyValue(price);
  const normalizedPriceRangeLow = normalizeCurrencyValue(priceRangeLow);
  const normalizedPriceRangeHigh = normalizeCurrencyValue(priceRangeHigh);
  const requiresRangeQuote = requiresRangeQuoteForVehicleType(vehicleType);

  useEffect(() => {
    return () => {
      if (submitUnlockTimeoutRef.current) {
        window.clearTimeout(submitUnlockTimeoutRef.current);
      }
    };
  }, []);

  const lockOrderSubmit = () => {
    setIsOrderSubmitDisabled(true);

    if (submitUnlockTimeoutRef.current) {
      window.clearTimeout(submitUnlockTimeoutRef.current);
    }

    submitUnlockTimeoutRef.current = window.setTimeout(() => {
      setIsOrderSubmitDisabled(false);
      submitUnlockTimeoutRef.current = null;
    }, ORDER_SUBMIT_LOCK_MS);
  };

  return (
    <>
      {quoteLineItems.length > 0 ? (
        <Row style={{ marginBottom: 16 }}>
          <Col className="col-10">
            <div style={{ color: '#fff', fontStyle: 'bold' }}>Quote Add-Ons:</div>
            {quoteLineItems.map(item => (
              <div key={item.code} style={{ color: '#cdcaca', marginTop: 6 }}>
                {item.label}
              </div>
            ))}
          </Col>
          <Col className="col-2" style={{ textAlign: 'right' }}>
            <div style={{ color: '#fff', fontStyle: 'bold' }}> </div>
            {quoteLineItems.map(item => (
              <div key={item.code} style={{ color: '#f7941d', marginTop: 6 }}>
                {item.amount !== null ? `$${item.amount.toFixed(2)}` : 'Included'}
              </div>
            ))}
          </Col>
        </Row>
      ) : null}
      <Row style={{ textAlign: 'right' }}>
        <Col className="col-10">
          <div style={{ color: '#fff', fontStyle: 'bold' }}>Shipping Type:</div>
          <div style={{ color: '#fff', fontStyle: 'bold' }}>Total Shipping Cost:</div>
        </Col>
        <Col className="col-2">
          <div style={{ color: '#fff' }}>{isExpedited ? 'Expedited' : 'Standard'}</div>
          {requiresRangeQuote ? (
            normalizedPriceRangeLow !== null && normalizedPriceRangeHigh !== null && (
              <div style={{ color: '#f7941d', fontStyle: 'bold' }}>
                {' '}
                Estimate ${normalizedPriceRangeLow.toFixed(2)} -- {normalizedPriceRangeHigh.toFixed(2)}
              </div>
            )
          ) : (
            <div style={{ color: '#f7941d', fontStyle: 'bold' }}>{normalizedPrice !== null ? '$' + normalizedPrice.toFixed(2) : null}</div>
          )}
        </Col>
      </Row>
      {isScheduled ? (
        <Row style={{ marginTop: 20 }}>
          <Col style={{ textAlign: 'left' }}>
            <div>
              <Button className="btn" color="default" style={{ paddingLeft: 57, paddingRight: 57 }} onClick={() => handleBack()}>
                Go Back
              </Button>
            </div>
            {/* <div>
              <Button className="btn cancel-btn" color="default" onClick={reset}>
                Cancel Order
              </Button>
            </div> */}
          </Col>
          <Col style={{ textAlign: 'right' }}>
            <div>
              <Button hidden={true}>Placeholder</Button>
            </div>
            <div>
              <Button
                className="btn submit-btn"
                color="danger"
                onClick={e => {
                  lockOrderSubmit();
                  handleConfirm('shipment_scheduled', 'order_scheduled', isScheduled);
                }}
                disabled={isOrderSubmitDisabled}
              >
                {requiresRangeQuote ? 'Get Quote and Schedule' : 'Schedule This Order'}
              </Button>
            </div>
            {requiresRangeQuote ? null : (
              <div>
                <Button
                  className="btn cancel-btn"
                  color="default"
                  onClick={e => {
                    setIsSaved(true);
                    setOrderStatus('order_saved');
                    setShipmentStatus('shipment_saved');
                    lockOrderSubmit();
                    handleConfirm('shipment_saved', 'order_saved');
                  }}
                  disabled={isOrderSubmitDisabled}
                  style={{ paddingLeft: 52, paddingRight: 52 }}
                >
                  Save for Later
                </Button>
              </div>
            )}
          </Col>
        </Row>
      ) : (
        <Row style={{ marginTop: 20 }}>
          <Col style={{ textAlign: 'left' }}>
            <div>
              <Button className="btn" color="default" style={{ paddingLeft: 57, paddingRight: 57 }} onClick={() => handleBack()}>
                Go Back
              </Button>
            </div>
            {/* <div>
              <Button className="btn cancel-btn" color="default" onClick={reset}>
                Cancel Order
              </Button>
            </div> */}
          </Col>
          <Col style={{ textAlign: 'right' }}>
            <div>
              <Button
                className="btn submit-btn"
                color="danger"
                onClick={e => {
                  lockOrderSubmit();
                  handleConfirm('shipment_ready_for_driver', 'awaiting_driver', isScheduled);
                }}
                disabled={isOrderSubmitDisabled}
              >
                {requiresRangeQuote ? 'Get Quote' : 'Ready for Pick Up'}
              </Button>
            </div>
            {requiresRangeQuote ? null : (
              <div>
                <Button
                  className="btn cancel-btn"
                  color="default"
                  onClick={e => {
                    setIsSaved(true);
                    setOrderStatus('order_saved');
                    setShipmentStatus('shipment_saved');
                    lockOrderSubmit();
                    handleConfirm('shipment_saved', 'order_saved', isScheduled);
                  }}
                  disabled={isOrderSubmitDisabled}
                  style={{ paddingLeft: 52, paddingRight: 52 }}
                >
                  Save for Later
                </Button>
              </div>
            )}
          </Col>
        </Row>
      )}
    </>
  );
};

export default ConfirmButtons;
